export const PACK_TASK_ROUTE_ROOT = '/pack-task';

export const PACK_TASK_ROUTES = {
  PACK_TASK: PACK_TASK_ROUTE_ROOT,
  PRINT: `${PACK_TASK_ROUTE_ROOT}/print`,
  SUMMARY: `${PACK_TASK_ROUTE_ROOT}/summary`,
  ALLOCATION_STAGING: `${PACK_TASK_ROUTE_ROOT}/allocation-staging`,
  CHECK_BASKET: `${PACK_TASK_ROUTE_ROOT}/check-basket`,
  WILDCARD: `${PACK_TASK_ROUTE_ROOT}/*`,
} as const;
